import { Map, MapDataSource } from "@aidkitorg/types/lib/survey";
import React, { useEffect, useState } from "react";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { BooleanExprToFilterGroupConverter, FilterGroupToBooleanExprConverter } from "../../shared/utils/filterConverters";

export const useMapFormState = (component?: Map) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')

  const [geographicDataOption, setGeographicDataOption] = useState('point')

  const [addressField, setAddressField] = useState('')
  const [geoJSONUrl, setGeoJSONUrl] = useState('')

  const [filterConfig, setFilterConfig] = useState<ReportFilterConfig | undefined>(undefined);

  useEffect(() => {
    if (!component) return

    const componentTitle = 'title' in component && component.title
      ? typeof component.title === 'string'
        ? component.title
        : component.title['en']
      : 'Dashboard Component';
    setTitle(componentTitle)
    setDescription(component.description || '')

    if (component.sources.length === 1) {
      const source = component.sources[0]

      switch (source.kind) {
        case 'Applicant Data Source':
          setGeographicDataOption('point')
          setAddressField(source.addressField)
          break;
        case 'URL GeoJSON Source':
          setGeographicDataOption('polygons')
          setGeoJSONUrl(source.url)
          break;
      }
    }

    // Initialize filter config from component
    if (component.filter) {
      try {
        const convertedFilter = BooleanExprToFilterGroupConverter.convert(component.filter);
        if (convertedFilter) {
          setFilterConfig({ enabled: true, config: convertedFilter });
        }
      } catch (error) {
        console.warn('Failed to convert saved filter config:', error);
      }
    }
  }, [component])

  const buildMapObject = (): Map => {
    const source = () => {
      switch(geographicDataOption) {
        case 'point':
          return {
            layerName: 'Address',
            kind: 'Applicant Data Source',
            filter: {
              kind: 'Not',
              clause: {
                kind: 'Never'
              }
            },
            columns: [],
            addressField: addressField
          } as MapDataSource
        case 'polygons':
          return {
            layerName: 'GeoJSON',
            kind: 'URL GeoJSON Source',
            url: geoJSONUrl
          } as MapDataSource
        default:
          return {
            layerName: 'Address',
            kind: 'Applicant Data Source',
            filter: {
              kind: 'Not',
              clause: {
                kind: 'Never'
              }
            },
            columns: [],
            addressField: addressField
          } as MapDataSource
      }}

    const map: Map = {
      kind: 'Map',
      sources: [source()],
      title: title,
      description: description
    }

    // Add filter if it's configured
    if (filterConfig && filterConfig.enabled && filterConfig.config) {
      const booleanExpr = FilterGroupToBooleanExprConverter.convertFromConfig(filterConfig);
      if (booleanExpr) {
        map.filter = booleanExpr;
      }
    }

    return map
  }

  return {
    title, setTitle,
    description, setDescription,
    geographicDataOption, setGeographicDataOption,
    addressField, setAddressField,
    geoJSONUrl, setGeoJSONUrl,
    filterConfig, setFilterConfig,
    buildMapObject
  }
}